// extracted by mini-css-extract-plugin
var _1 = "Credits_container__zEYMl";
var _2 = "Credits_item__SyHGY";
var _3 = "768px";
var _4 = "\"../../shared.module.css\"";
var _5 = "Credits_tooltip__l+RYj";
export { _1 as "container", _2 as "item", _3 as "md", _4 as "shared", _5 as "tooltip" }
